<script setup lang="ts">
definePageMeta({
  title: 'Cable Termination',
  order: 1,
  description: 'Fastest cutting and stripping in the West.',
})
</script>

<template>
  <section>
    <BlockContent>
      <h1 class="mb-4 uppercase font-flex-100-151-640">
        Cable Termination
      </h1>
      <h2 class="subpage-title">
        No Loose Ends
      </h2>
      <h3 class="subpage-subtitle mt-2">
        The PowerStrip 9580 makes termination fast and precise
      </h3>
      <div class="my-10 gap-x-4 gap-y-8 grid grid-cols-1 md:grid-cols-2">
        <div>
          <div class="text-lg max-w-prose space-y-4">
            <p>
              The Schleuniger PowerStrip 9580 is capable of handling a diverse array of applications and stands out for its modular, adaptable, and upgradeable machine design. ICS is able to deliver exceptional production efficiency coupled with precise processing, making it an automatic cut & strip machine of superior quality.
            </p>
            <p>
              Discrete wires with cross sections up to 70 mm² (2/0 AWG), shielded cable and complex multiconductor applications can be processed in one automated operation.
            </p>
            <p class="text-sm uppercase">
              Cutting & Stripping Operations:
            </p>
            <ul class="text-base px-4 list-disc">
              <li>Cut to length</li>
              <li>Full or partial strip left and right</li>
              <li>Jacket and inner conductor stripping</li>
              <li>Jacket stripping of extremely thin insulations</li>
              <li>Jacket stripping of multiconductor cables</li>
              <li>Multilayer stripping</li>
              <li>Multilayer with shield processing (coax, hybrid, etc.)</li>
              <li>Multistep jacket stripping with inner conductor stripping and window slitting</li>
              <li>Multistep stripping</li>
              <li>Trimming, separating and stripping of individual zipcord conductors</li>
              <li>Wire marking</li>
            </ul>
          </div>
          <nav class="my-10 flex flex-wrap gap-6">
            <AButton
              label="Get a Quote"
              to="/contact/rfq"
              color="blue"
            />
            <AButton
              label="The PowerStrip 9580"
              to="https://www.schleuniger.com/en/products/cut-strip/powerstrip-9580/"
              color="gray"
              material="empty"
              new-tab
            />
          </nav>
          <NuxtLink
            to="https://www.schleuniger.com/en/"
            class="group py-4 flex-inline gap-3 h-11 items-center"
          >
            <NuxtImg
              src="03dbacf9-f5dc-4fed-bf32-6632e04df183"
              alt="The Schleuniger logo."
              class="w-28"
            />
            <div class="i-carbon-launch transition-colors group-hover:bg-icssilver-800 dark:group-hover:bg-icssilver-200" />
          </NuxtLink>
        </div>
        <NuxtImg
          class="w-full transition-opacity object-cover dark:opacity-80"
          src="2a9fbaf3-706d-4684-948b-bda285c943d3"
          alt="The Schleuniger PowerStrip 9580 cutting and stripping machine isolated on a white background."
        />
      </div>

      <!-- <ACard element="aside">
        <template #header>
          <h6 class="text-xl font-flex-400">
            Cutting & Stripping 101
          </h6>
          <hr class="my-4 b-icsgray">
        </template>
        Put some light educational content here for SEO.
      </ACard> -->
    </BlockContent>
  </section>
</template>
